import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { FooterPanelNotifier } from './footer-panel-notifier';
import { FooterPanelState } from './footer-panel-state';

@Injectable()
export class FooterPanelProvider extends BaseProvider<FooterPanelNotifier, FooterPanelState> {
  constructor() {
    super(FooterPanelNotifier);
  }
}
